// helpers.js (puedes colocarlo en el mismo archivo arriba del componente también)
const MONTHS_SHORT_ES = [
  "ene",
  "feb",
  "mar",
  "abr",
  "may",
  "jun",
  "jul",
  "ago",
  "sep",
  "oct",
  "nov",
  "dic",
];

export const getMonthName = (monthNumber) => {
  return MONTHS_SHORT_ES[monthNumber - 1] || "";
};

export const formatDate = (dateStr) => {
  if (!dateStr) return "-";
  const [year, month, day] = dateStr.split("-");
  if (!year || !month || !day) return "-";
  return `${day} ${getMonthName(parseInt(month, 10))} ${year}`;
};

export const formatNumber = (num) => {
  if (num == null || isNaN(num)) return "-";
  return Number(num).toLocaleString("es-MX");
};
